import { map } from 'lodash';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';

import { DataDetailListProps } from './data-detail-list';

export function DataDetailListMinimal({
  heading,
  rows,
  headingStyle,
}: DataDetailListProps) {
  return (
    <div>
      {heading && (
        <h6 className="pb-2 fw-bold" style={headingStyle}>
          {heading}
        </h6>
      )}
      <Table
        size="small"
        sx={{
          backgroundColor: 'transparent',
          '& .MuiTableCell-root': {
            border: 0,
            backgroundColor: 'transparent',
            padding: '4px 0',
          },
        }}
      >
        <TableBody>
          {map(rows, (row, idx) => (
            <TableRow
              key={idx}
              className={row.className}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
              }}
            >
              <TableCell
                className={`fw-bold text-nowrap label ${row?.labelClassName ?? ''}`}
                sx={{
                  width: '50%',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                }}
              >
                {row.label}&nbsp;
              </TableCell>
              <TableCell className="value">{row.value || '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
